import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Behöver föreningen tillstånd för årsfest med vin?";
const SHORT_ANSWER = "Om alkoholen serveras mot ersättning (även dolt i biljettpris eller medlemsavgift) krävs tillfälligt tillstånd till slutet sällskap.";

export const Route = createFileRoute("/fraga/far-jag-foreningens-arsfest-utan-tillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Behöver föreningen tillstånd för årsfest med vin" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Bjuder föreningen helt på alkoholen utan koppling till någon avgift behövs normalt inget tillstånd – men gränsen är glidande. Säkerheten i tveksamma fall är att söka tillstånd."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd för förening" }}
      related={[{"to": "/fraga/far-jag-ha-tillstand-utan-fysisk-lokal", "label": "Kan jag få serveringstillstånd utan fast lokal?"}, {"to": "/fraga/food-truck-vad-galler", "label": "Vad gäller för food truck och alkoholservering?"}, {"to": "/fraga/hur-lange-far-tillfalligt-tillstand-vara", "label": "Hur länge kan ett tillfälligt serveringstillstånd gälla?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Behöver föreningen tillstånd för årsfest med vin?" },
      { name: "description", content: "Om alkoholen serveras mot ersättning (även dolt i biljettpris eller medlemsavgift) krävs tillfälligt tillstånd till slutet sällskap." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-foreningens-arsfest-utan-tillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-foreningens-arsfest-utan-tillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-foreningens-arsfest-utan-tillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Behöver föreningen tillstånd för årsfest med vin", url: "https://alkoholprovet.se/fraga/far-jag-foreningens-arsfest-utan-tillstand" },
      ]),
    ],
  }),
});
